module.exports = __webpack_public_path__ + "static/eb-1-0a9f837a7e74e288e29d42c6461b16c9.mp4";